import styled from "styled-components";
import Toast from "react-bootstrap/Toast";

export const ToastContainer = styled(Toast)`
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  font-size: 14px;
  font-weight: 600;
`;

export const ToastBodySuccess = styled(Toast.Body)`
  background-color: ${({ theme }) => theme.greenBackground};
  color: #fff;
`;

export const ToastBodyError = styled(Toast.Body)`
  background-color: #b70000;
  color: #fff;
`;
